const Precision = Object.freeze({
  HIGH: 'HIGH',
  LOW: 'LOW',
  DEFINED: 'DEFINED',
  DEFAULT: 'DEFAULT'
})
export default Precision
export type PrecisionStrings = typeof Precision[keyof typeof Precision]
// RESERVE BELOW
